/* =========================================================
 * GoogleTagManager（GTM） でのWeb解析のための関数をまとめる
========================================================= */
/* ---------------------------------------------------------
 enableGtmArticleAlgorithmTracking
 # 説明
 検索結果や、募集ページ下部の関連ボランティア等で、「どの募集ページが、表示順位何位で、どの程度クリックされたか」などのGTM（GA4）を使ってトラッキングする。

 # 使い方
 1. articlesを表示するWrapperに、`#gtm`接頭辞で始まるIDセレクタを指定
 2. Wrapper内のBox（各articleの導線リンクの部分）に対して、`.gtmEventArticleAlgorithm`セレクタを指定
 3. WrapperとBox、それぞれのセレクタの要素にて、`data-gtm-◯◯`を自由に追加することで、rendering時とselect時にGTMへパラメータとして送信できる
 4. ※ページURLなどは`pageGtmData`にて直で書く
--------------------------------------------------------- */
function enableGtmArticleAlgorithmTracking() {
  const commonArticleBoxSelector = ".gtmEventArticleAlgorithm";
  window.addEventListener("gtm_article_algorithm_rendering", (e) => {
    const articlesWrapper = $(e.detail.wrapperSelector);
    addPagePositionData(articlesWrapper);
    bulkTrackRendering(articlesWrapper);
    enableSelectTracking(articlesWrapper);
  });

  function bulkTrackRendering(articlesWrapper) {
    const articleBoxes = articlesWrapper.find(commonArticleBoxSelector);
    articleBoxes.each((_, articleBox) => trackRendering(articleBox));

    function trackRendering(articleBox) {
      window.dataLayer.push({
        event: "article_algorithm_rendering",
        ...parseToGtmDataFrom(articleBox.dataset),
        ...parseToGtmDataFrom(articlesWrapper.data()),
        ...pageGtmData(),
      });
    }
  }

  function enableSelectTracking(articlesWrapper) {
    const articleBoxes = articlesWrapper.find(commonArticleBoxSelector);
    articleBoxes.on("click", (e) => {
      const articleBox = e.currentTarget;
      trackSelect(articleBox);
      $(articleBox).off("click"); // 重複クリックをカウントしないように
    });

    function trackSelect(articleBox) {
      window.dataLayer.push({
        event: "article_algorithm_select",
        ...parseToGtmDataFrom(articleBox.dataset),
        ...parseToGtmDataFrom(articlesWrapper.data()),
        ...pageGtmData(),
      });
    }
  }

  /* 共通のサブ処理
  --------------------------------------------------------- */
  function parseToGtmDataFrom(data) {
    if (!data) return {};
    return Object.fromEntries(
      Object.keys(data)
        .filter(
          (key) => key.startsWith("gtm") && !key.startsWith("gtmEcommerce")
        ) // NOTE: eコマース用のデータは除外
        .map((key) => [parseKey(key), data[key]])
    );
  }

  function pageGtmData() {
    return {
      pageCat: pageCategory(),
      pagePath: `${location.pathname}${location.search}`,
      pageVorJ: pageVolOrJob(),
    };

    function pageCategory() {
      return currentPage("body.articles.show")
        ? "articles_show"
        : currentPage("body.search.searchresult")
        ? "search_searchresult"
        : currentPage("body.search.bookmark")
        ? "search_bookmark"
        : currentPage("body.search.recent")
        ? "search_recent"
        : "other";

      function currentPage(selector) {
        return document.querySelector(selector) != null;
      }
    }

    function pageVolOrJob() {
      return location.pathname.startsWith("/job") ? "job" : "volunteer";
    }
  }

  // 接頭辞の「gtm」の文字を削除したり、最初の文字を小文字にするだけの処理
  function parseKey(str) {
    if (typeof str !== "string" || !str) return str;
    return str.charAt(3).toLowerCase() + str.slice(4);
  }

  function addPagePositionData(articlesWrapper) {
    const page = pageNum();
    articlesWrapper
      .find(commonArticleBoxSelector)
      .each(
        (i, articleBox) => (articleBox.dataset.gtmP = i + 1 + (page - 1) * 30)
      );
  }

  function pageNum() {
    const urlParams = new URLSearchParams(location.search);
    return Number(urlParams.get("page") || "1");
  }
}

/* ---------------------------------------------------------
 enableGtmGAUserIDTracking
 # 説明
 GA4の「User-ID」をページキャッシュに考慮して送信する。
 GA4への設定自体はGTM（タグマネージャー）にてトリガーしている。
--------------------------------------------------------- */
function enableGtmGAUserIDTracking(json) {
  if (window.location.href.includes("preview")) return; // NOTE: manage/supporter_acquire_settings/editのプレビューでロードされるため追加。
  let ga_user_id;
  if (json.current_user) {
    // 団体ユーザーとしてログインしている場合を優先する
    ga_user_id = `user_${json.current_user.id}`;
  } else if (json.current_person) {
    ga_user_id = `person_${json.current_person.id}`;
  }
  if (ga_user_id) {
    dataLayer.push({
      event: "UserID Fetched",
      ga_user_id,
    });
  }
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export { enableGtmArticleAlgorithmTracking, enableGtmGAUserIDTracking };
